var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerritories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 45,
    viewBox: "0 0 35 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3066 34.1529C6.1517 33.0113 -0.524064 25.0975 0.0538364 16.0714C0.631737 7.04527 8.26455 0.0112156 17.4932 4.84202e-06C26.7342 -0.00673876 34.3865 7.03131 34.9652 16.0694C35.5438 25.1074 28.8492 33.0276 19.6799 34.1529V38.5971C28.3084 38.7943 34.9865 40.1464 34.9865 41.7857C34.9865 43.56 27.1539 45 17.4932 45C7.8326 45 0 43.56 0 41.7857C0 40.1464 6.67804 38.7943 15.3066 38.5971V34.1529ZM17.4932 30C24.7392 30 30.6132 24.2437 30.6132 17.1429C30.6132 10.0421 24.7392 4.28572 17.4932 4.28572C10.2473 4.28572 4.37331 10.0421 4.37331 17.1429C4.37331 24.2437 10.2473 30 17.4932 30ZM13.1199 17.1429C13.1199 19.5098 15.0779 21.4286 17.4932 21.4286C19.9085 21.4286 21.8665 19.5098 21.8665 17.1429C21.8665 14.7759 19.9085 12.8571 17.4932 12.8571C15.0779 12.8571 13.1199 14.7759 13.1199 17.1429Z",
    fill: "#19C1D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerritories);
export default __webpack_public_path__ + "static/media/territories.671440da51101c24eb37355ec8a02cca.svg";
export { ForwardRef as ReactComponent };